import type { NotificationSummary } from "@/modules/notifications/domain/repo/notification-summary";
import type { AdminNotificationRow } from "@/modules/notifications/domain/repo/list-notifications";
import type { OffsetPageDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { NotificationSummary, AdminNotificationRow };

export const notificationsApi = {
  async getSummary(): Promise<NotificationSummary> {
    return fetcher.get<NotificationSummary>(
      `${config.apiUrl}/notifications/summary`,
    );
  },

  async getUnreadCount(): Promise<{ count: number }> {
    return fetcher.get<{ count: number }>(
      `${config.apiUrl}/notifications/unread-count`,
    );
  },

  async list(params?: {
    limit?: number;
    offset?: number;
    unreadOnly?: boolean;
    type?: string;
  }): Promise<OffsetPageDTO<AdminNotificationRow>> {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set("limit", String(params.limit));
    if (params?.offset != null) search.set("offset", String(params.offset));
    if (params?.unreadOnly) search.set("unreadOnly", "true");
    if (params?.type) search.set("type", params.type);
    const qs = search.toString();
    return fetcher.get<OffsetPageDTO<AdminNotificationRow>>(
      `${config.apiUrl}/notifications${qs ? `?${qs}` : ""}`,
    );
  },

  async markRead(id: string): Promise<{ ok: true }> {
    return fetcher.post<{ ok: true }>(
      `${config.apiUrl}/notifications/${id}/read`,
    );
  },

  async markAllRead(): Promise<{ marked: number }> {
    return fetcher.post<{ marked: number }>(
      `${config.apiUrl}/notifications/read-all`,
    );
  },
};
